import { useTranslation } from 'react-i18next';

import {
    Button,
    Center,
    HighlightedCard,
    Stack,
    Subtitle1,
    Subtitle2,
} from '@myphx-engineering/phx-design-system';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import type { PrescriptionOffer } from '../../../../hooks/use-prescription-offers';
import { getAbsoluteRoute } from '../../../../util/get-absolute-route';

export type SelectInsurancePathCardProps = {
    offer: PrescriptionOffer | undefined;
};

export const SelectInsurancePathCard = ({
    offer,
}: SelectInsurancePathCardProps) => {
    const { t } = useTranslation('lilly');
    const { drxId } = useFillPrescription();

    const line1 =
        offer?.headlinePriceType === 'CopayAssistance'
            ? t('fill.insurance.pathSelect.cards.insurance.line1')
            : t('fill.insurance.pathSelect.cards.insurance.line1NoCard');
    const line2 =
        !offer || offer.headlinePriceType === 'InsuredPriceAtPharmacy'
            ? t('fill.pathSelect.cards.line2NoPrice')
            : offer.headlinePriceType === 'CopayAssistance'
              ? t('fill.pathSelect.cards.line2', {
                    price: offer.patientCost,
                })
              : t('fill.pathSelect.cards.line2PriceOnly', {
                    price: offer.patientCost,
                });

    return (
        <HighlightedCard
            fullWidthFooter
            pinFooter
            fullHeight
            data-testid="path-select-card-insurance"
            header={
                <Center data-testid="path-select-card-insurance-title">
                    {t('fill.insurance.pathSelect.cards.insurance.heading')}
                </Center>
            }
            footer={
                <Button
                    fullWidth
                    link
                    to={{
                        pathname: getAbsoluteRoute('fill.drxId.root', {
                            drxId,
                        }),
                        search: `?pathway=insurance`,
                    }}
                >
                    {t('fill.insurance.pathSelect.cards.insurance.button')}
                </Button>
            }
        >
            <Stack gap="md">
                <Subtitle2>{line1}</Subtitle2>
                <Subtitle1>{line2}</Subtitle1>
            </Stack>
        </HighlightedCard>
    );
};
